import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { EmailService } from "../../../modulos/general/componentes/gestion-terceros/servicios/email.service";
import { GestionEmailService } from "../../../modulos/panel-control/componentes/gestion-email/gestion-email.service";
import { ModalMailComponent } from "./modal-mail.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule
    ],
    declarations: [
        ModalMailComponent
    ],
    exports: [
        ModalMailComponent
    ],
    providers: [
        EmailService,
        GestionEmailService
    ]
})
export class ModalMailModule { }
